import React, { useEffect, useRef } from 'react'
import * as d3 from 'd3'
import { Row, Col } from 'antd'
import { CHART_COLORS } from '../../util/chartPalette'

const PatientPie = (props) => {
  const ref = useRef(null)

  useEffect(() => {
    drawpiecharts()
  })

  var drawpiecharts = () => {
    d3.select('#piegroup' + props.index).remove()
    let svg = d3.select(ref.current)
    let count = props.data
    // Pie shows only complete / partial / skipped — "remaining" is intentionally
    // excluded from the chart (it still appears in the text list on the right).
    var label = ['complete', 'partial', 'incomplete']
    var data = [
      count?.completeddays,
      count?.partialdays,
      count?.incompletedays,
    ]
    var width = svg.attr('width')
    var height = svg.attr('height')
    var radius = Math.min(width, height) / 2
    var g = svg
      .append('g')
      .attr('id', 'piegroup' + props.index)
      .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')')
    // Not-yet-started patient (no complete/partial/skipped days yet): the pie
    // would have nothing to draw, so show a faint empty ring placeholder.
    var total = data.reduce(function (sum, v) {
      return sum + (Number(v) || 0)
    }, 0)
    if (!total) {
      g.append('circle')
        .attr('r', radius - 1)
        .attr('fill', 'none')
        .attr('stroke', CHART_COLORS.remainingGray)
        .attr('stroke-width', 2)
        .attr('opacity', 0.5)
      return
    }
    var color = d3.scaleOrdinal([
      CHART_COLORS.completeGreenSoft,
      CHART_COLORS.partialYellow,
      CHART_COLORS.skippedRed,
    ])
    var pie = d3.pie()
    var arc2 = d3.arc().innerRadius(0).outerRadius(radius)
    var arcs2 = g
      .selectAll('arc2')
      .data(pie(data))
      .enter()
      .append('g')
      .attr('stroke', 'white')
      .attr('stroke-width', '0')
      .attr('class', 'arc2')
    arcs2
      .append('path')
      .attr('fill', function (d, i) {
        return color(i)
      })
      .attr('d', arc2)
      .append('svg:title') // TITLE APPENDED HERE
      .text(function (d, i) {
        return data[i] + ' ' + label[i]
      })
  }

  return (
    <Row
      justify={props.align ? props.align : 'center'}
      style={{
        textAlign: 'left',
        minWidth: 140,
        width: props.width ? props.width : '100%',
      }}
    >
      <Col flex={'70px'} style={{ alignSelf: 'center' }}>
        <svg ref={ref} width='60' height='60'></svg>
      </Col>
      <Col flex={'140px'}>
        <Row style={{ color: CHART_COLORS.completeGreenSoft }}>
          <Col span={12}>Complete</Col>
          <Col span={80}>
            {' '}
            : {Math.round(props.data?.completeddays || 0)}
            {Math.round(props.data?.completeddays || 0) == 1 ? ' Day' : ' Days'}
          </Col>
        </Row>
        <Row style={{ color: CHART_COLORS.partialYellow }}>
          <Col span={12}>Partial</Col>
          <Col span={80}>
            : {Math.round(props.data?.partialdays || 0)}
            {Math.round(props.data?.partialdays || 0) == 1 ? ' Day' : ' Days'}
          </Col>
        </Row>
        <Row style={{ color: CHART_COLORS.skippedRed }}>
          <Col span={12}>Skipped</Col>
          <Col span={80}>
            : {Math.round(props.data?.incompletedays || 0)}
            {Math.round(props.data?.incompletedays || 0) == 1 ? ' Day' : ' Days'}
          </Col>
        </Row>
        <Row style={{ color: '#aaaaaa' }}>
          <Col span={12}>Remaining </Col>
          <Col span={80}>
            : {Math.round(props.data?.remainingdays || 0)}
            {Math.round(props.data?.remainingdays || 0) == 1 ? ' Day' : ' Days'}
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default PatientPie
